// src/hooks/pricingUnits/useRestorePricingUnit.js
import { useMutation, useQueryClient } from "@tanstack/react-query";
import toast from "react-hot-toast";
import { restorePricingUnit } from "../../api/apiPricingUnits";
import parseError from "../../utils/parseError";

const useRestorePricingUnit = () => {
    const queryClient = useQueryClient();

    const {
        mutate: restorePricingUnitMutation,
        isPending,
        isLoading,
    } = useMutation({
        mutationFn: restorePricingUnit,
        onSuccess: (response) => {
            toast.success(response.message);
            queryClient.invalidateQueries({ queryKey: ["pricingUnits"] });
        },
        onError: (error) => {
            const message = parseError(error);
            toast.error(message || "Failed to restore pricing unit");
        },
    });

    return {
        restorePricingUnit: restorePricingUnitMutation,
        isPending: isPending || isLoading,
    };
};

export default useRestorePricingUnit;
